import { EventTravelLegType } from "Bands/types";
import { FC } from "react";
import { TravelMap as TravelMapComponent } from "shared/components";
import { StyledTravelMapWrapper } from "./style";

interface Props {
  travelLegs?: EventTravelLegType[];
}

export const TravelMap: FC<Props> = ({ travelLegs }) => {
  return (
    <StyledTravelMapWrapper>
      <TravelMapComponent travelLegs={travelLegs} />
    </StyledTravelMapWrapper>
  );
};
